import React from 'react'

import { reportErrorMessage } from 'utils/errorReporter'
import ProcessRow from '../ProcessRow'

import styles from '../styles'
import SkippedProcessCourtsRelation from './SkippedProcessCourtsRelation'

const BuildProcesses = (props) => {
  const { processData } = props

  const classes = styles()
  
  const renderError = () => {
    const errorMsg = 'Ocorreu um erro ao tratar os dados de Processos Judiciais'
    reportErrorMessage(errorMsg, 'BuildProcesses')
    
    return (
      <div className={classes.errorCaptured}>
        <span>{errorMsg}</span>
      </div>
    )
  }
  
  return (
    <div className={classes.processesRoot}>
      
      <SkippedProcessCourtsRelation processData={processData} />
      
      <div className="processes_resume">
        <h3>Resumo de processos do candidato</h3>
        <p>
          <span>Possui processos de qualquer natureza? </span>
          {processData?.has_any_process ? 'Sim' : 'Não'}
        </p>
        {processData.has_any_process ? (
          <React.Fragment>
            <p>
              <span>Possui processos criminais? </span>
              {processData?.has_criminal_process ? 'Sim' : 'Não'}
            </p>
            <p>
              <span>Possui processos não criminais? </span>
              {processData?.has_non_criminal_process ? 'Sim' : 'Não'}
            </p>
            <p>
              <span>Possui processos movidos por entidade regulatória? </span>
              {processData?.has_process_from_regulatory_entity ? 'Sim' : 'Não'}
            </p>
            <p>
              <span>Possui penalidades financeiras? </span>
              {processData?.has_financial_penalty ? 'Sim' : 'Não'}
            </p>
            <p>
              <span>Possui processos com palavras-chave de risco? </span>
              {processData?.has_process_with_risk_keywords ? 'Sim' : 'Não'}
            </p>
            <p>
              <span>Possui processos administrativos? </span>
              {processData?.has_administrative_process ? 'Sim' : 'Não'}
            </p>
            <p>
              <span>Possui processos judiciais? </span>
              {processData?.has_judicial_process ? 'Sim' : 'Não'}
            </p>
          </React.Fragment>
        ) : null}
      </div>
      {processData ? (
        processData?.processes?.length > 0 ? (
          <div className="processes_list">
            {processData?.processes?.map((process) => {
              return (
                <ProcessRow
                  key={`process:${process.uuid}`}
                  processData={process}
                />
              )
            })}
          </div>
        ) : (
          <div className={classes.expansibleContent}>
            <span>Nenhum registro encontrado.</span>
          </div>
        )
      ) : renderError()}
    </div>
  )
}

export default BuildProcesses
